import action from '../helpers/rest-client'
import { AssignLicenseOutDto, RevokeLicenseOutDto } from '../types/license.dto'

export class ErrorLicense extends Error { }

const path = '/license'

class License {
  public getAll({ filters }) {
    const filtersJSON = filters && Object.keys(filters).length > 0 ? `?filters=${JSON.stringify(filters)}` : ``
    return action
      .Get({
        url: `${path}${filtersJSON}`,

      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public assign(payload: AssignLicenseOutDto) {
    const { user, idLicense } = payload
    return action
      .Patch({
        url: `${path}/${idLicense}/assign`,
        body: { user }
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public revoke(payload: RevokeLicenseOutDto) {
    const { user, idLicense } = payload
    return action
      .Patch({
        url: `${path}/${idLicense}/revoke`,
        body: { user }
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }
}

const license = new License()
export default license
